export default function EmptyState({ message }: { message: string }) {
    return (
        <div className="catalog-empty">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#adb5bd" strokeWidth="1.3" strokeLinecap="round">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
            </svg>
            <p className="catalog-empty-title">{message}</p>
        </div>
    );
}
